// removed by extract-text-webpack-plugin
module.exports = {"overlay":"flipperSection__overlay--Rh-tU","dots":"flipperSection__dots--2ts-L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/FlipperSection/flipperSection.css
// module id = W3o1
// module chunks = 0